import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getters'
import parent_node from './parent_node'
import template_list from './template_list'
import premium_app from './premium_app'
import theme from './theme'
import morejoy_assistant from './morejoy_assistant'
import model_list from './model_list'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    parent_node, // 注册数据
    template_list, // 注册数据
    premium_app,
    theme,
    morejoy_assistant,
    model_list
  },
  getters
})

export default store
